var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcyfLogoFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    title: "Washington State Department of Children, Youth, and Families logo",
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-dcyf-logo-footer)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.865 16.47s-1.091-4.854.39-5.43c1.482-.576 3.006 2.613 4.161 1.727 1.156-.886 0-3.173-2.831-4.887-2.832-1.715-6.719-1.538-6.719-1.538M7.68 15.591s.552-3.77-.934-4.283c-1.487-.514-2.385 2.53-3.392 1.528-1.007-1.003.846-2.633 2.039-3.542 1.192-.909 3.222-1.557 5.995-1.61",
    stroke: "#fff",
    strokeWidth: 0.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.528 22.712c6.207 0 11.24-5.02 11.24-11.212S17.734.288 11.527.288.288 5.308.288 11.5s5.033 11.212 11.24 11.212z",
    stroke: "#fff",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.514 5.692c.962 0 1.741-.778 1.741-1.737 0-.959-.78-1.736-1.74-1.736-.962 0-1.742.777-1.742 1.736 0 .96.78 1.737 1.741 1.737zM8.234 7.166c.75 0 1.36-.607 1.36-1.356 0-.749-.61-1.356-1.36-1.356-.75 0-1.36.607-1.36 1.356 0 .75.61 1.356 1.36 1.356z",
    stroke: "#fff",
    strokeWidth: 0.85,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.668 11.308a1.12 1.12 0 001.122-1.12A1.12 1.12 0 0011.67 9.07a1.12 1.12 0 00-1.122 1.119 1.12 1.12 0 001.121 1.119z",
    stroke: "#fff",
    strokeWidth: 0.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.305 14.123c-.383-1.167-.974-1.916-1.637-1.916-.74 0-1.39.932-1.761 2.337-.02.077-.04.155-.058.234 0 0-.048.232-.065.336",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.821 19.217c.13-.058.252-.118.375-.177 1.152-.562 2.201-1.31 3.107-2.215.406-.658.736-1.36.983-2.092-4.262 3.34-8.222 2.828-8.222 2.828 3.445-2.734 1.066-3.1 1.066-3.1-.676.828-4.437 3.302-8.905 1.058a7.424 7.424 0 01-3.918-5.169 10.232 10.232 0 001.365 6.381 10.27 10.27 0 004.948 4.267 10.3 10.3 0 006.526.425 10.278 10.278 0 005.462-3.589 9.789 9.789 0 01-1.616.966c-.37.19-.764.33-1.171.417z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-dcyf-logo-footer"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23v23H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcyfLogoFooter);
export default __webpack_public_path__ + "static/media/dcyf-logo-footer.8f00f832.svg";
export { ForwardRef as ReactComponent };